import translations from '../translations/translations'

window.reportModel = function(args = {}) {

	var _translate = function(key) {

      var lang = args.printLanguage;

      if ( ! translations.translations[key] ) {
        return '[undefined string]';
      }
      
      var s = translations.translations[key];
      return (s[lang]) ? s[lang] : s['en']  + ' [' + lang.toUpperCase() + ']';

  },

  _prints = function(string, s) {
      return string.replace('%s', s);
  },

	isEmpty = function(obj) {

	  for(var prop in obj) {

	  	if(obj.hasOwnProperty(prop)) {

        return false;

	    }

	  }

	  return JSON.stringify(obj) === JSON.stringify({});

	},

	chartExists = function(id) {

		var img = document.getElementById(id);

		if ( img === undefined || img === null ) {

			return false;

		}

		return true;

	},

	/**
	 * Method: getDetails()
	 *
	 * Attempts to return a set of details for use on
	 * the cover page
	 * 
	 * @return {object} an object of the desired data points, for use
	 * when generating the cover page.
	 */
	getDetails = function() {

		var date = new Date(),
		    dateString = date.getMonthName() + ' ' + date.getDate() + ', ' + date.getFullYear();

		var ob = args.details;
		    ob.date = dateString;

		return ob;

	},

	getClientDetails = function() {

		return {

			name: 'John Doe',

		}

	},

	getAddress = function(address) {

		var addressText = '';

		for ( var x = 0; x < address.length; x++ ) {

			if ( x > 0 ) {

				addressText += '\n';

			}

			addressText += address[x];

		}

		return addressText;

	},

	detailsMargin = function() {

		var margin = 240;

		if ( details.clientAddress.length > 0 ) {

			margin -= (16.5 * details.clientAddress.length);

		}		

		return margin;

	},

	clientAddressMargin = function() {

		var margin = 28;

		if ( details.clientAddress.length > 0 ) {

			margin += (16.5 * details.clientAddress.length);

		}

		return margin;

	},

	coverBreak = function() {

		if ( args.useCover ) {

			return 'before';

		}

		return false;

	},

	bottomMargin = function() {

		var margin = 51,
		    lines = (details.disclaimer.length > 180) ? Math.ceil(details.disclaimer.length / 180) : 1;

    margin += 7 + (10 * (lines - 1));

		return margin;

	},


	/** LAYOUTS */

	getTableLayout = function(layout) {

		if ( layout === 'noBorder' ) {

			return 	{
        hLineWidth: function(i, node) {
          return 0;
        },
        vLineWidth: function(i, node) {
          return 0;
        },
        hLineColor: function(i, node) {
          return 'transparent';
        },
        vLineColor: function(i, node) {
          return 'transparent';
        },
        paddingLeft: function(i, node) { return 0; },
        paddingRight: function(i, node) { return 0; },
        paddingTop: function(i, node) { return 0; },
        paddingBottom: function(i, node) { return 0; }
      }

		}

		if ( layout === 'profile' ) {

			return {
				hLineWidth: function(i, node) {
          return (i === 0 || i === node.table.body.length) ? 1 : 0.5;
        },
        vLineWidth: function(i, node) {
          return 0;
        },
        hLineColor: function(i, node) {
          return (i === 0 || i === node.table.body.length) ? '#ddd' : '#eee';
        },
        vLineColor: function(i, node) {
          return (i === 0 || i === node.table.widths.length) ? '#ddd' : '#eee';
        },
        paddingLeft: function(i, node) { return 0; },
        paddingRight: function(i, node) { return 0; },
        paddingTop: function(i, node) { return 15; },
        paddingBottom: function(i, node) { return 15; }
      }

		}

		if ( layout === 'profile-compact' ) {

			return {
				hLineWidth: function(i, node) {
          return (i === 0 || i === node.table.body.length) ? 1 : 0.5;
        },
        vLineWidth: function(i, node) {
          return 0;
        },
        hLineColor: function(i, node) {
          return (i === 0 || i === node.table.body.length) ? '#ddd' : '#eee';
        },
        vLineColor: function(i, node) {
          return (i === 0 || i === node.table.widths.length) ? '#ddd' : '#eee';
        },
        paddingLeft: function(i, node) { return 0; },
        paddingRight: function(i, node) { return 0; },
        paddingTop: function(i, node) { return 12; },
        paddingBottom: function(i, node) { return 12; }
      }

		}

		if ( layout === 'netWorth' ) {

			return {
				hLineWidth: function(i, node) {
          return (i === 0 || i === node.table.body.length) ? 0.5 : 0.5;
        },
        vLineWidth: function(i, node) {
          return 0;
        },
        hLineColor: function(i, node) {
          return (i === 0 || i === node.table.body.length) ? '#bbb' : '#eee';
        },
        vLineColor: function(i, node) {
          return (i === 0 || i === node.table.widths.length) ? '#bbb' : '#eee';
        },
        paddingLeft: function(i, node) { return 0; },
        paddingRight: function(i, node) { return 0; },
        paddingTop: function(i, node) { return 3; },
        paddingBottom: function(i, node) { return 3; }
      }

		}

	},


	/** COMPONENTS */

	sectionHeading = function(text) {

		var breakType = false;

		if ( args.firstPage ) {

			args.firstPage = false;

		}

		else {

			breakType = 'before';

		}

		var component = [

			{ 

				text: text,
				style: 'heading',
				margin: [0, 0, 0, 10],
				pageBreak: breakType,

			},

			{

      	alignment: 'center',
      	margin: [0, 0, 40, 0],
				canvas: [

					{
						type: 'line',
						x1: 0, y1: 0,
						x2: 40, y2: 0,
						lineWidth: 1,
						lineColor: '#f5cc45',
					},

				]		   

			},	

		]

		return component;

	},

	sectionIntro = function(text) {

		var component = [

			{

				text: text,
				style: 'intro',
				margin: [0, 15, 80, 40],

			}

		];

		return component;

	},

	sectionGraph = function(id, width = 480, margins = false) {

		var img = document.getElementById(id);

		if ( ! chartExists(id) ) {

			return {};

		}

		var component = {

			image: img.toDataURL('image/jpeg', 0.75),
			width: width,

		}

		if ( Array.isArray(margins) ) {

			component.margin = margins;

		}

		return component;

	},

	sectionLegend = function(data) {

		if ( ! data ) {

			return {};

		}

		var component = {

			layout: getTableLayout('noBorder'),
			table: {

				widths: [14, '*'],
				body: [[]]

			}

		}

		var n = 0;
		for ( var x = 0; x < data.fields.length; x++ ) {

			if ( data.fields[x].color !== undefined ) {

				component.table.body[n] = [
					{ 
						canvas: [

							{
								type: 'rect',
								x: 0,
								y: 4,
								w: 8,
								h: 8,
								color: data.fields[x].color,
							},

						]

					},

					{

						text: _translate(data.fields[x].name),
						style: 'textCellSmall',
						margin: [0, 3, 0, 3],

					}

				];

				n += 1;

			}

		}

		return component;

	},

	sectionProfileDetails = function() {

		var obj = [[]],
		    index = 0,
		    inc = 0,
		    labels = {

		    	birthdate:       _translate('panel.dob'),
		    	gender:          _translate('panel.gender'),
		    	maritalStatus:   _translate('panel.maritalStatus'),
		    	spouse:          _translate('panel.spouse'),
		    	phoneHome:       _translate('panel.homePhone'),
		    	phoneWork:       _translate('panel.workPhone'),
		    	phoneCell:       _translate('panel.cellPhone'),
		    	fax:             _translate('panel.faxNumber'),
		    	email:           _translate('panel.email'),
		    	employer:        _translate('panel.employer'),
		    	occupation:      _translate('panel.occupation'),
		    	employerAddress: _translate('panel.employerAddress'),

		    };

		for ( var field in labels ) {

			if ( labels[field] !== undefined &&
				   details.clientDetails[field] !== '' &&
				   details.clientDetails[field] !== null ) {

		    if ( obj[index] === undefined ) {

		    	obj[index] = [];

		    }

		    obj[index][inc++] = {
					text: labels[field],
					style: 'labelCell',
				};

				obj[index][inc++] = {
					text: ( field === 'employerAddress' ) 
						? getAddress(details.clientDetails[field]) 
						: details.clientDetails[field],
					style: 'textCell',
				}

			}

			if ( inc > 3 ) {

				inc = 0;
				index += 1;

			}

		}

		if ( inc < 3 && inc > 0 ) {

			obj[index][inc++] = {};
			obj[index][inc]   = {};

		}

		return obj;

	},


	/**
	 * FUNCTION: sectionNetWorthTable()
	 * @param  {String} type - the type of table, used as an array key to distinguish assets/liabilities
	 * @param  {Number} col - fixed index value
	 * @return {Array} - returns an array of "rows" for PDFMake.js to use to create the actual table.
	 */
	sectionNetWorthTable = function(type, col) {

		// Define the empty array, which the function will then populate.
		var a = [[]],

				// Define an object of labels, as pulled from the translation object.
				// This allows us to define the specific labels that appear within the
				// chart for different items.
		    labels = {

          chequing:    _translate('netWorth.chequingAccounts'),
          savings:     _translate('netWorth.savingsAccounts'),

          tfsa:        _translate('panel.tfsaTitle'),
          // bonds:       _translate('Bonds'),
          stocks:      _translate('panel.stocks'),
          mutualFunds: _translate('netWorth.savings'),
          mutualFundsR: _translate('netWorth.registered'),          
          // gics:        _translate('GICs'),
          rrif:        _translate('netWorth.rrifs'),
          other:       _translate('panel.other'),

          realEstateHome: _translate('netWorth.familyHome'),
          realEstateOther: _translate('netWorth.otherRealEstate'),
          personalProperty: _translate('netWorth.personalProperty'),
          businessInterest: _translate('netWorth.businessInterests'),
          taxDefered: _translate('panel.taxDeferredAssets'),

          employerPension: _translate('netWorth.employerPensionPlan'),
          dpspEsopGrsp: _translate('netWorth.dpspEsopGrsp'),
          lockedRrsp: _translate('netWorth.lockedinRrsp'),

          creditCards: _translate('netWorth.creditCards'),
          carLoans: _translate('netWorth.carLoans'),
          lineOfCredit: _translate('netWorth.lineOfCredit'),
          otherLiabilities: _translate('netWorth.otherLiabilities'),

          'mortgageHome': _translate('netWorth.mortgageOnHome'),
          'mortgageOther': _translate('netWorth.otherMortgages'),
          'investmentLoans': _translate('netWorth.investmentLoans'),

		    },

		    sections = {

		    	liquid: _translate('netWorth.liquidAssets'),
		    	semiLiquid: _translate('netWorth.semiliquidAssets'),
		    	rrsp: _translate('netWorth.retirementSavings'),
		    	other: _translate('netWorth.otherAssets'),
		    	shortTerm: _translate('netWorth.shortTermDebt'),
		    	longTerm: _translate('netWorth.longTermDebt'),

		    }

		var x = 0;

		// If the target "type" is empty, we'll just return a default array, indicating
		// that no data is available.
		if ( isEmpty(details.netWorth[type][col - 1]) ) {

			return [
				[
					{
						text: 'No data available.',
						colSpan: 2,
						style: 'textCellSmall',
						italics: true,
						characterSpacing: .25,
						color: '#555',
					}
				]
			];

		}

		// Now we trigger the actual loop where we start iterating across the data points.
		// We start by looping over the main sections.
		for ( var k in details.netWorth[type][col - 1] ) {

			// For each section, define section title as its own row.
			a[x] = [
				{
					text: sections[k].toUpperCase(),
					colSpan: 2,
					style: 'sectionCellSmall',
				},
				{}
			];
			x += 1;

			// Then we'll loop through all of the individual items within that section.
			for ( var y in details.netWorth[type][col - 1][k] ) {

				a[x] = [ 
					{
						// text: labels[y],
						// style: 'labelCellSmall',
						// margin: [3, 0, 0, 0]
						layout: getTableLayout('noBorder'),
						table: {

							widths: [14, '*'],
							body: [

								[

									{
										canvas: [

											{
												type: 'rect',
												x: 0,
												y: 0,
												w: 8,
												h: 8,
												color: details.netWorth[type][col - 1][k][y].color,
											},

										]		   

									},

									{
										text: labels[y],
										style: (args.useNetworthBreakdown) ? 'labelCellSmallBold' : 'labelCellSmall',
									}

								]

							]

						}

					},

					sectionNetWorthTableValue(details.netWorth[type][col - 1][k][y].value, args.useNetworthBreakdown),

				];

				x += 1;

				// If the account breakdown option is turned on, we want to actually provide
				// the account breakdown data here. 
				if ( args.useNetworthBreakdown ) {

					var accounts = details.netWorth[type][col - 1][k][y].accounts;

					// Only output if the accounts object is empty
					if ( accounts ) {
						
						for ( var act in accounts ) {

							var valString = 'display', accountName;

							// Sometimes, there might be an empty repeater field. Make sure the field
							// actually has data.
							if ( accounts[act][valString] !== undefined && accounts[act][valString] !== '' ) {

								accountName = ( accounts[act].name ) ? accounts[act].name : '';
								if ( accounts[act].institution ) {
									if ( accountName.length > 0 ) { 
										accountName += '\n';
									}
									accountName += '(' + accounts[act].institution + ')';
								}

								a[x] = [ 
									{
										// text: labels[y],
										// style: 'labelCellSmall',
										// margin: [3, 0, 0, 0]
										layout: getTableLayout('noBorder'),
										table: {

											widths: [14, '*'],
											body: [

												[

													{
														canvas: [

															{
																type: 'rect',
																x: 0,
																y: 0,
																w: 8,
																h: 8,
																color: '#FFFFFF',
															},

														]		   

													},

													{
														text: accountName,
														style: 'labelCellSmall',
													}

												]

											]

										}

									},

									sectionNetWorthTableValue(accounts[act][valString], false),

								];

								x += 1;
							}

						}

					}

				}


			}

		}

		return a;

	},


	/**
	 * FUNCTION sectionNetWorthTableValue();
	 * @param  {String} value - the actual value of the line item
	 * @return {Object} - return the formatted object for PDFMake.js use in its formatting.
	 *
	 * This function basically outputs the actual value cell of the Net Worth report tables.
	 */
	sectionNetWorthTableValue = function(value, bold = false) {

		if ( value === undefined || value === '' ) {
			return '';
		}

		// If there is a second line in the value, it is because we've included the spouse data.
		// We'll want to split that out. 
		var split_value = value.split('\n'),
				textStyle = (bold) ? 'textCellSmallBold' : 'textCellSmall',

				// Here we start outputting the lines object, which we will pass back as the returned
				// value of this function.
		    lines = {
		    		layout: getTableLayout('noBorder'),
						table: {

							widths: ['*'],
							body: [ [{text: split_value[0], style: textStyle, alignment: 'right'}] ]

						}
		    };

		// If the previous split did provide a second line, we'll also want to print this out
		// as the spouse value.
		if ( split_value[1] !== undefined ) {
			lines.table.body[1] = [{text: split_value[1], style: textStyle, alignment: 'right', margin: [0, 4, 0, 0]}]
		};

		return lines;

	},

	sectionWealthTable = function(data, extend = false) {

		if ( ! data ) {

			return {};
			
		}	

		var component = {

			layout: getTableLayout('netWorth'),
			table: {

				headerRows: 1,
				widths: [],

				body: [[]],	
			}

		}

		if ( extend ) {

			component.margin = [-30, 0, -30, 0];

		}

		for ( var x = 0; x < data.fields.length; x++ ) {

			component.table.body[0][x] = {
				text: _translate(data.fields[x].name),
				style: 'sectionCellSmall'
			};

			component.table.widths[x] = data.fields[x].width;

		}

		for ( var x = 0; x < data.values.length; x++ ) {

			var row = [];

			for ( var i = 0; i < data.fields.length; i++ ) {

				row[i] = {
					text: data.values[x][data.fields[i].field],
					style: 'textCellSmall',
				};

			}

			component.table.body[x + 1] = row;

		}

		return component;

	},

	sectionRetirementOverviews = function() {

		var component = [],
		    n = 0;

			if ( details.retirementPlanner.outlook !== undefined ) {

				component[n] = [

					{

						text: _translate('retirementPlanner.outlookTitle'),
						style: 'heading2',
						margin: (n === 0 || n === 2) ? [0, 0, 0, 10] : [0, 25, 0, 10],
						pageBreak: (n === 2) ? 'before' : false,

					},

					{

						margin: [0, 0, 0, 0],
						layout: getTableLayout('profile'),
						table: {

							widths: [130, '*', 130, '*'],
							body: [

								[

									{
										text: _translate('retirementPlanner.presentAge'),
										style: 'labelCell',
									},
									{
										text: details.retirementPlanner.retirement.age,
										style: 'textCell',
									},									{
										text: _translate('retirementPlanner.yearsInRetirement'),
										style: 'labelCell',
									},
									{
										text: details.retirementPlanner.outlook.years,
										style: 'textCell',
									},					

								],

								[


									{
										text: _translate('retirementPlanner.ageToRetire'),
										style: 'labelCell',
									},
									{
										text: details.retirementPlanner.retirement.ageRetire,
										style: 'textCell',
									},
									{
										text: _translate('retirementPlanner.ageOfPassiveRetirement'),
										style: 'labelCell',
									},
									{
										text: details.retirementPlanner.retirement.agePassive,
										style: 'textCell',
									}																

								],

								[

									{
										text: _translate('retirementPlanner.estimatedLifeExpectancy'),
										style: 'labelCell',
									},
									{
										text: details.retirementPlanner.retirement.lifeExpectancy,
										style: 'textCell',
									},
									{},
									{}							

								],

								[

									{
										text: _translate('pdf.incomeRequiredInPassiveRetirement'),
										style: 'labelCell',
									},
									{
										text: details.retirementPlanner.retirement.targetPassivePercent,
										style: 'textCell',
									},
									{
										text: _prints(_translate('pdf.targetIncomeAtRetirement'), details.retirementPlanner.retirement.ageRetire),
										style: 'labelCell',
									},
									{
										text: details.retirementPlanner.retirement.targetIncome,
										style: 'textCell',
									}										

								],

								[

									{
										text: _translate('pdf.projectedRateOfInflation'),
										style: 'labelCell',
									},
									{
										text: details.retirementPlanner.retirement.rateInflation,
										style: 'textCell',
									},
									{
										text: _translate('pdf.projectedRateOfReturn'),
										style: 'labelCell',
									},
									{
										text: details.retirementPlanner.retirement.rateReturn,
										style: 'textCell',
									}										

								]	

							],

						},

					}

				];

				n += 1;

			}

			if ( details.retirementPlanner.government !== undefined ) {

				component[n] = [

					{

						text: _translate('retirementPlanner.governmentBenefits'),
						style: 'heading2',
						margin: (n === 0 || n === 2) ? [0, 0, 0, 10] : [0, 25, 0, 10],
						pageBreak: (n === 2) ? 'before' : false,

					},

					{

						margin: [0, 0, 0, 0],
						layout: getTableLayout('profile'),
						table: {

							widths: [130, '*', 130, '*'],
							body: [

								[

									{
										text: _translate('pdf.currentMaximumCppPayout'),
										style: 'labelCell',
									},
									{
										text: details.retirementPlanner.government.currentMaxCPP,
										style: 'textCell',
									},
									{
										text: _translate('pdf.currentMaximumOasPayout'),
										style: 'labelCell',
									},
									{
										text: details.retirementPlanner.government.currentMaxOAS,
										style: 'textCell',
									}							

								],

								[

									{
										text: _prints(_translate('pdf.projectedEligibleCppAtAgeOf'), details.retirementPlanner.government.ageCPP),
										style: 'labelCell',
									},
									{
										text: details.retirementPlanner.government.projectCPP,
										style: 'textCell',
									},
									{
										text: _prints(_translate('pdf.projectedOasAtAgeOf'), details.retirementPlanner.government.ageOAS),
										style: 'labelCell',
									},
									{
										text: details.retirementPlanner.government.projectOAS,
										style: 'textCell',
									}					

								],

								[

									{
										text: _translate('panel.cppIndex'),
										style: 'labelCell',
									},
									{
										text: details.retirementPlanner.government.indexCPP,
										style: 'textCell',
									},
									{
										text: _translate('panel.oasIndex'),
										style: 'labelCell',
									},
									{
										text: details.retirementPlanner.government.indexOAS,
										style: 'textCell',
									},							

								],			

							],

						},
						
					},
				
				];

				n += 1;

			}

			if ( details.retirementPlanner.investments !== undefined ) {

				var i = 0,
				    b = [],
				    groups = {
				    	regular:    _translate('pdf.regularTitle'),
				    	tfsa:       _translate('pdf.tfsaTitle'),
				    	registered: _translate('pdf.registeredTitle'),
				    	dpsp:       _translate('pdf.dpspTitle'),
				    	lockedin:   _translate('pdf.lockedinTitle'),
				    }

				for ( var x in groups ) {

					if (details.retirementPlanner.investments[x + 'Print']) {

						b[i++] = [
							{
								text: groups[x],
								style: 'labelCellBold',
								colSpan: 4,
							},{},{},{}
						],

						b[i++] = [

							{
								text: _translate('retirementPlanner.summaryCurrentValue'),
								style: 'labelCell',
							},
							{
								text: details.retirementPlanner.investments[x + 'Value'],
								style: 'textCell',
							},
							{
								text: _translate('retirementPlanner.summaryTotalValueAtRetirement'),
								style: 'labelCell',
							},
							{
								text: details.retirementPlanner.investments[x + 'Projected'],
								style: 'textCell',
							}							

						];

						b[i++] = [

							{
								text: _translate('retirementPlanner.summaryTotalContributions'),
								style: 'labelCell',
							},
							{
								text: details.retirementPlanner.investments[x + 'Contribute'],
								style: 'textCell',
							},
							{
								text: _translate('retirementPlanner.summaryRateOfReturn'),
								style: 'labelCell',
							},
							{
								text: details.retirementPlanner.investments[x + 'Return'],
								style: 'textCell',
							}							

						];

					}	

				}							

				if ( b.length > 0 ) {
					
					component[n] = [			

						{

							text: 'Asset Values',
							style: 'heading2',
							margin: (n === 0 || n === 2) ? [0, 0, 0, 10] : [0, 25, 0, 10],
							// pageBreak: (n === 2) ? 'before' : false,
							pageBreak: 'before',

						},

						{

							margin: [0, 0, 0, 0],
							layout: getTableLayout('profile-compact'),
							table: {

								widths: [130, '*', 130, '*'],
								body: b,

							},
							
						},
						
					];

				n += 1;

				}

			}

			if ( details.retirementPlanner.pension !== undefined ) {

				component[n] = [

					{

						text: _translate('panel.pension'),
						style: 'heading2',
						margin: (n === 0 || n === 2) ? [0, 0, 0, 10] : [0, 25, 0, 10],
						pageBreak: 'before', //(n > 1) ? 'before' : false,

					},

					{

						margin: [0, 0, 0, 0],
						layout: getTableLayout('profile'),
						table: {

							widths: [130, '*', 130, '*'],
							body: [

								[

									{
										text: _translate('pdf.startReceivingPensionAtAge'),
										style: 'labelCell',
									},
									{
										text: details.retirementPlanner.pension.pensionAge,
										style: 'textCell',
									},
									{
										text: _translate('panel.cppIntegrate'),
										style: 'labelCell',
									},
									{
										text: (details.retirementPlanner.pension.integrateCPP) ? 'Yes' : 'No',
										style: 'textCell',
									}							

								],

								[

									{
										text: _translate('retirementPlanner.projectedInitialBenefit'),
										style: 'labelCell',
									},
									{
										text: (details.retirementPlanner.pension.projectedBenefit),
										style: 'textCell',
									},
									{
										text: _translate('panel.indexPension'),
										style: 'labelCell',
									},
									{
										text: details.retirementPlanner.pension.pensionIndex,
										style: 'textCell',
									}					

								],

								[

									{
										text: _translate('panel.hasBridgeBenefit'),
										style: 'labelCell',
									},
									{
										text: (details.retirementPlanner.pension.hasBridge) ? _translate('pdf.yes') : _translate('pdf.no'),
										style: 'textCell',
									},
									{
										text: (details.retirementPlanner.pension.hasBridge) ? _translate('retirementPlanner.brdigeBenefitAmount') : '',
										style: 'labelCell',
									},
									{
										text: (details.retirementPlanner.pension.hasBridge) ? details.retirementPlanner.pension.bridgeAmount : '',
										style: 'textCell',
									},							

								],				

							],

						},
						
					},
				
				];

				if ( details.retirementPlanner.pension.hasBridge ) {

					component[n][1].table.body[component[n][1].table.body.length] = [

						{
							text: _translate('retirementPlanner.bridgeBenefitStarts'),
							style: 'labelCell',
						},
						{
							text: details.retirementPlanner.pension.bridgeStart,
							style: 'textCell',
						},
						{
							text: _translate('retirementPlanner.bridgeBenefitEnds'),
							style: 'labelCell',
						},
						{
							text: details.retirementPlanner.pension.bridgeEnd,
							style: 'textCell',
						}										

					];	

				}

				n += 1;

			}			
			
			return component;

	},


	/** MODULES */

	module_clientProfile = function() {

		if ( ! args.useProfile ) {

			return {};

		}

		var module = [

			sectionHeading(_translate('pdf.clientProfile')),

			{

				text: details.clientName.toUpperCase(),
				style: 'heading2',
				margin: [0, 25, 0, 0],

			},

			{ 

				text: getAddress(details.clientAddress),
				style: 'intro',
				margin: [0, 15, 0, 0],

			},

			{

				margin: [0, 15, 0, 0],
				layout: getTableLayout('profile'),
				table: {
					widths: [70, '*', 70, '*'],
					body: sectionProfileDetails ()
				}
			},			

		];

		var i = module.length,
		    x = 0;

		if ( args.details.clientDetails.beneficiaryName !== '' ||
		     args.details.clientDetails.beneficiaryAge !== '') {

			x = 0;

			module[i++] = {

				text: _translate('pdf.beneficiary'),
				style: 'heading2',
				margin: [0, 15, 0, 0],

			};

			module[i++] = {

				margin: [0, 15, 0, 0],
				layout: getTableLayout('profile'),
				table: {
					widths: [70, '*', 70, '*'],
					body: [[]]
				}

			};

			if ( args.details.clientDetails.beneficiaryName ) {

				module[i - 1].table.body[0][x++] = {

					text: _translate('pdf.name'),
					style: 'labelCell',

				};

				module[i - 1].table.body[0][x++] = {

					text: args.details.clientDetails.beneficiaryName,
					style: 'labelCell',

				};

			}

			if ( args.details.clientDetails.beneficiaryAge ) {

				module[i - 1].table.body[0][x++] = {

					text: _translate('pdf.age'),
					style: 'labelCell',

				};

				module[i - 1].table.body[0][x++] = {

					text: args.details.clientDetails.beneficiaryAge,
					style: 'labelCell',

				};

			}

			if ( x < 3 ) {

				module[i - 1].table.body[0][x++] = {};
				module[i - 1].table.body[0][x++] = {};

			}

		}	

		if ( args.details.clientDetails.executorName !== '' ||
		     args.details.clientDetails.executorAge !== '') {

			x = 0;

			module[i++] = {

				text: _translate('pdf.executor'),
				style: 'heading2',
				margin: [0, 15, 0, 0],

			};

			module[i++] = {

				margin: [0, 15, 0, 0],
				layout: getTableLayout('profile'),
				table: {
					widths: [70, '*', 70, '*'],
					body: [[]]
				}

			};

			if ( args.details.clientDetails.executorName ) {

				module[i - 1].table.body[0][x++] = {

					text: _translate('pdf.name'),
					style: 'labelCell',

				};

				module[i - 1].table.body[0][x++] = {

					text: args.details.clientDetails.executorName,
					style: 'labelCell',

				};

			}

			if ( args.details.clientDetails.executorAge ) {

				module[i - 1].table.body[0][x++] = {

					text: _translate('pdf.age'),
					style: 'labelCell',

				};

				module[i - 1].table.body[0][x++] = {

					text: args.details.clientDetails.executorAge,
					style: 'labelCell',

				};

			}

			if ( x < 3 ) {

				module[i - 1].table.body[0][x++] = {};
				module[i - 1].table.body[0][x++] = {};

			}			

		}

		return module;

	},

	module_netWorth = function() {

		if ( ! args.useNetWorth ) {

			return {};

		}

		var assetsMargin      = (chartExists(details.netWorth.charts.assets)) ? [0, 20, 10, 0] : [0, 200, 10, 0],
				liabilitiesMargin = (chartExists(details.netWorth.charts.liabilities)) ? [10, 20, 0, 0] : [10, 200, 0, 0];

		var module = [

			sectionHeading(_translate('netWorth.title')),
			sectionIntro(_translate('pdf.netWorthIntro')),
			
			( args.useNetworthTotal ) ? sectionGraph(details.netWorth.charts.netWorth, 400, [0, -30, 40, 0]) : {},

			( args.useNetworthTotal ) ? {

				layout: getTableLayout('profile'),
				margin: [0, 30, 0, 0],
				table: {

					widths: ['50%', '50%'],
					body: [

						[

							{

								layout: getTableLayout('noBorder'),
								table: {

									widths: [14, '*'],
									body: [

										[

											{ 

												canvas: [

													{
														type: 'rect',
														x: 0,
														y: 4,
														w: 8,
														h: 8,
														color: details.netWorth.totals.assets.color,
													},

												]		   

											},

											{ 

												'text': _translate('netWorth.assetsTotal'),
												'style': 'labelCellLarge',

											}

										]

									]

								}

							},

							{ 

								'alignment': 'right',
								'text': details.netWorth.totals.assets.value,
								'style': 'textCellLarge'

							}

						],

						[

							{

								layout: getTableLayout('noBorder'),
								table: {

									widths: [14, '*'],
									body: [

										[

											{ 

												canvas: [

													{
														type: 'rect',
														x: 0,
														y: 4,
														w: 8,
														h: 8,
														color: details.netWorth.totals.liabilities.color,
													},

												]		   

											},

											{ 

												'text': _translate('netWorth.assetsLiabilities'),
												'style': 'labelCellLarge',

											}

										]

									]

								}

							},

							{ 

								'alignment': 'right',
								'text': details.netWorth.totals.liabilities.value,
								'style': 'textCellLarge'
							}

						],

						[

							{

								layout: getTableLayout('noBorder'),
								table: {

									widths: [14, '*'],
									body: [

										[

											{ 

												canvas: [

													{
														type: 'rect',
														x: 0,
														y: 4,
														w: 8,
														h: 8,
														color: details.netWorth.totals.netWorth.color,
													},

												]		   

											},

											{ 

												'text': _translate('netWorth.title'),
												'style': 'labelCellLarge',

											}

										]

									]

								}

							},

							{ 

								'alignment': 'right',
								'text': details.netWorth.totals.netWorth.value,
								'style': 'textCellLarge'

							}

						],											

					]
				}

			} : {},

			( args.useNetworthComp ) ? {

				text: '',
				style: 'heading2',
				margin: [0, 0, 0, 10],
				pageBreak: ( args.useNetWorthTotal ) ? false : 'before',

			} : {},

			( args.useNetworthComp ) ? {

				layout: getTableLayout('noBorder'),
				margin: [0, -15, 0, 0],
				table: {

					widths: ['50%', '50%'],
					body: [

						[

							[

								[sectionGraph(details.netWorth.charts.assets, 180, [25, 0, 25, 0])],

								{

									layout: getTableLayout('noBorder'),
									margin: assetsMargin, //[0, 20, 10, 0],
									table: {

										widths: ['50%', '50%'],
										body: [

											[

												{
													text: _translate('netWorth.assetsTotal'),
													style: 'tableHeading',

												},

												{ 

													text: details.netWorth.totals.assets.value,
													alignment: 'right',
													style: 'tableHeadingVal',

												}

											]

										]

									}

								},

								{

									layout: getTableLayout('netWorth'),
									margin: [0, 5, 10, 0],
									table: {

										body: sectionNetWorthTable('assets', 1),
										widths: [130, '*'],

									}

								}

							],					

							[

								[sectionGraph(details.netWorth.charts.liabilities, 180, [30, 0, 20, 0])],

								{

									layout: getTableLayout('noBorder'),
									margin: liabilitiesMargin, //[10, 20, 0, 0],
									table: {

										widths: ['50%', '50%'],
										body: [

											[

												{
													text: _translate('netWorth.assetsLiabilities'),
													style: 'tableHeading',

												},

												{ 

													text: details.netWorth.totals.liabilities.value,
													alignment: 'right',
													style: 'tableHeadingVal',
													color: '#ed7220',

												}

											]

										]

									}

								},								

								{

									layout: getTableLayout('netWorth'),
									margin: [10, 5, 0, 0],
									table: {

										body: sectionNetWorthTable('liabilities', 1),
										widths: [130, '*'],

									}

								}								

							],

						],

					]

				}

			} : {},

		];

		return module;

	},

	module_retirementPlan = function() {

		if ( ! args.useRetirementPlanner ) {

			return {};

		}

		var module = [

			sectionHeading(_translate('retirementPlanner.title')),
			sectionIntro(_translate('pdf.retirementPlannerIntro')),

		]

		var i = module.length,
        b = 'none';

    if ( args.useRetirementOutlook ||
         args.useRetirementIncome ||
         args.useRetirementBenefits ||
         args.useRetirementPension ||
         args.useRetirementValues ) {

    	module[i++] = sectionRetirementOverviews();

      b = 'before';

    }

		if ( details.retirementPlanner.wealthAccumulation !== undefined &&
		     args.useRetirementWealthAccumulation ) { 

			module[i++] = [ 

				{

					text: _translate('retirementPlanner.wealthAccumulation'),
					style: 'heading2',
					margin: [0, 0, 0, 10],
					pageBreak: b,

				},

				(args.useRetirementWealthAccumulationGraph) ? {

					layout: getTableLayout('noBorder'),
					margin: [0, 0, 0, 15],
					table: {

						widths: [390, '*'],
						body: [

							[

								sectionGraph(details.retirementPlanner.wealthAccumulation.chart, 380),
								sectionLegend(details.retirementPlanner.wealthAccumulation),

							]

						]

					}

				} : {},

				(args.useRetirementWealthAccumulationTable) ? sectionWealthTable(details.retirementPlanner.wealthAccumulation) : {},

			];

      b = 'before';

		}

		if ( details.retirementPlanner.wealthDeaccumulation !== undefined &&
			   args.useRetirementDeacumulation ) {

			module[i++] = [

				{

					text: _translate('retirementPlanner.deaccumulation'),
					style: 'heading2',
					margin: [0, 0, 0, 10],
					pageBreak: b,

				},

				(args.useRetirementDeacumulationGraph) ? {

					layout: getTableLayout('noBorder'),
					margin: [0, 0, 0, 15],
					table: {

						widths: [390, '*'],
						body: [

							[

								sectionGraph(details.retirementPlanner.wealthDeaccumulation.chart, 380),
								sectionLegend(details.retirementPlanner.wealthDeaccumulation),

							]

						]

					}

				} : {},

				(args.useRetirementDeacumulationTable) ? sectionWealthTable(details.retirementPlanner.wealthDeaccumulation) : {},

			]; 

      b = 'before';			

		}

		if ( details.retirementPlanner.retirementCashFlows !== undefined &&
			   args.useRetirementCashflows ) {

			var extend = false;

			if ( details.retirementPlanner.retirementCashFlows.fields.length > 8 ) { extend = true; }

			module[i++] = [ 

				{

					text: _translate('retirementPlanner.postRetirementCashFlows'),
					style: 'heading2',
					margin: [0, 0, 0, 10],
					pageBreak: b,

				},

				(args.useRetirementCashflowsGraph) ? {

					layout: getTableLayout('noBorder'),
					margin: [0, 0, 0, 15],
					table: {

						widths: [390, '*'],
						body: [

							[

								sectionGraph(details.retirementPlanner.retirementCashFlows.chart, 380),
								sectionLegend(details.retirementPlanner.retirementCashFlows),

							]

						]

					}

				} : {},

				(args.useRetirementCashflowsTable) ? sectionWealthTable(details.retirementPlanner.retirementCashFlows, extend) : {},

			];

      b = 'before';			

		}

		return module;

	},

	module_disclaimers = function() {

		if ( ! args.useDisclaimers ) {

			return {};

		};

		var module = [
			sectionHeading(_translate('disclaimers.title')),
		];

		var n = module.length;

		for ( var index in details.disclaimers ) {

			module[n++] = [
				{

					text: [

						_translate(details.disclaimers[index].title),

					],
					style: 'heading2',
					margin: [0, 25, 0, 15],

				},
			]

			for ( var i in details.disclaimers[index].list ) {

				module[n++] = [

					{

						text: [

							{ 
								text: _translate(details.disclaimers[index].list[i].term),
								bold: true,
								color: '#000000',
							},
							' - ',
							_translate(details.disclaimers[index].list[i].def),

						],
						style: 'intro',
						margin: [0, 15, 0, 0],

					}

				]

			}

		}

		/** 
		 * If the global disclaimers section is checked in the print modal, we need to include
		 * those details in the disclaimers section of the report. Here we make a quick check,
		 * then add the required data to the PDF object, if required.
		 */
		if (args.useDisclaimersGlobal) {

			module[n++] = {
				text: [

					{ 
						text: _translate('disclaimers.copyright'),
					},

				],
				style: 'intro',
				margin: [0, 25, 0, 0],
			}

			module[n++] = {
				text: [

					{
						text: _translate('disclaimers.disclaimers'), 
						link: _translate('links.disclaimers'),
						color: '#06a0df'
					},
					{
						text: '  |  ',
						color: '#aaaaaa'
					},
					{
						text: _translate('disclaimers.legalText'), 
						link: _translate('links.legal'),
						color: '#06a0df'
					},
					{
						text: '  |  ',
						color: '#aaaaaa'
					},
					{
						text: _translate('disclaimers.privacyText'), 
						link: _translate('links.privacy'),
						color: '#06a0df'
					},
					{
						text: '  |  ',
						color: '#aaaaaa'
					},
					{
						text: _translate('disclaimers.complaintText'), 
						link: _translate('links.complaint'),
						color: '#06a0df'
					}

				],
				style: 'intro',
				margin: [0, 0, 0, 0],
			}

			module[n++] = {
				text: [

					{ 
						text: _translate('disclaimers.general'),
						italics: true
					},

				],
				style: 'intro',
				margin: [0, 15, 0, 0],
			}

			module[n++] = {
				text: [

					{ 
						text: _translate('disclaimers.general2'),
						italics: true
					},

				],
				style: 'intro',
				margin: [0, 15, 0, 0],
			}

		}		

		return module;				

	},

	module_tool = function() {

		if ( ! args.useTool ) {

			return {};

		};

		var hasDetail = (details.tool.detail !== undefined &&
	                   details.tool.detail !== false &&
	                   details.tool.detailHighlight !== undefined && 
	                   details.tool.detailHighlight !== false &&
	                   args.useToolChart ),
		    b = false,
		    m = 30,
		    n = 0;

		if ( args.useToolChart ) {

			b = 'before'
			m = 0;

		}

		var module = [
			sectionHeading(details.tool.title)
		];

	  if ( args.useToolChart ) {

			n = module.length;

			if (hasDetail) {

				module[n++] = [

					{

						text: [

							details.tool.detail,
							' ',
							{
								text: details.tool.detailHighlight,
								color: '#06a0df',
							}

						],
						style: 'heading2',
						margin: [0, 25, 0, 15],

					},

				];

			}

			module[n++] = {

				layout: getTableLayout('noBorder'),
				margin: (hasDetail) ? [0, 0, 0, 15] : [0, 25, 0, 15],
				table: {

					widths: [390, '*'],
					body: [

						[

							sectionGraph(details.tool.chart, 380),
							sectionLegend(details.tool),

						]

					]

				}

			};		

	    var inputs = {

				layout: getTableLayout('profile'),
				margin: [0, 30, 0, 0],
	    	table: {

					widths: ['50%', '50%'],
	    		body: [],

	    	}

	    };

			for ( var x = 0; x < details.tool.inputs.length; x++ ) {

				inputs.table.body[x] = [
					{
						text: details.tool.inputs[x].name,
						style: 'labelCellLarge',
					},
					{
						text: details.tool.inputs[x].value,
						style: 'textCellLarge',
						alignment: 'right',
					}				
				]

			}

			module[n++] = inputs;

		}

		if ( args.useToolTable ) {

			n = module.length;
			module[n] = [

				{

					text: ( args.useToolChart ) ? details.tool.title + ' - Summary' : 'Summary',
					style: 'heading2',
					margin: [0, m, 0, 10],
					pageBreak: b,

				},

				{

					layout: getTableLayout('netWorth'),
					margin: [0, 5, 0, 15],
					table: {

						widths: [],
						body: []

					}

				}

			];

			module[n][1].table.body[0] = [];
			for ( var x = 0; x < details.tool.summary.dataPoints.length; x++ ) {

				module[n][1].table.body[0][x] = {
					text: details.tool.summary.dataPoints[x].label,
					style: 'sectionCellSmall',
				}
				module[n][1].table.widths[x] = (details.tool.summary.dataPoints[x].field === 'year') ? 70 : '*';

			}

			for ( x = 0; x < details.tool.summary.data.length; x++ ) {

				module[n][1].table.body[x + 1] = [];

				for ( var y = 0; y < details.tool.summary.dataPoints.length; y++ ) {

					var field = details.tool.summary.dataPoints[y].field;
					module[n][1].table.body[x + 1][y] = {
						text: details.tool.summary.data[x][field],
						style: 'sectionCellSmall',
					};

				}

			}

		}

		return module

	},

	module_financialGPS = function() {

		if ( ! args.useGPS ) {

			return {};

		};

		module = [

			sectionHeading(_translate('financialGps.title')),
      sectionIntro(_translate('pdf.retirementPlannerIntro')),

		];

		var i = module.length,
		    b = 'none';

		if ( args.useGPSOverview ) {

			module[i++] = {

				text: details.clientName.toUpperCase(),
				style: 'heading2',
				margin: [0, -15, 0, 15],

			};

			module[i++] = {

				margin: [0, 0, 0, 15],
				layout: getTableLayout('profile'),
				table: {

					widths: [130, '*', 130, '*'],
					body: [

						[
							{
								text: _translate('financialGps.currentAge'),
								style: 'labelCell',
							},

							{
								text: details.financialGPS.details.currentAge,
								style: 'textCell',
								colSpan: 3,
							},
							'',
							''

						],

						[
							{
								text: _translate('financialGps.planStartingYear'),
								style: 'labelCell',
							},

							{
								text: details.financialGPS.details.planStartingYear,
								style: 'textCell',
							},

							{
								text: _translate('financialGps.currentYear'),
								style: 'labelCell',
							},

							{
								text: details.financialGPS.details.currentYear,
								style: 'textCell',
							},

						],

						[
							{
								text: _translate('financialGps.ageAtRetirement'),
								style: 'labelCell',
							},

							{
								text: details.financialGPS.details.retirementAge,
								style: 'textCell',
							},

							{
								text: _translate('financialGps.yearOfRetirement'),
								style: 'labelCell',
							},

							{
								text: details.financialGPS.details.retirementYear,
								style: 'textCell',
							},

						],

					]

				},

			};

			module[i++] = {

				text: [
					_translate('pdf.currentValue') + ' ',
					{
						text: details.financialGPS.details.currentValue,
						color: '#06a0df',
					}
				],
				margin: [0, 15, 0, 30],
				style: 'heading2',

			};

			module[i++] = {

				margin: [0, 0, 0, 15],
				layout: getTableLayout('profile'),
				table: {

					widths: [130, '*', 130, '*'],
					body: [

						[
							{
								text: _translate('financialGps.startingAssets'),
								style: 'labelCell',
							},

							{
								text: details.financialGPS.details.startingAssets,
								style: 'textCell',
							},

							{
								text: _translate('financialGps.assetGoalAtRetirement'),
								style: 'labelCell',
							},

							{
								text: details.financialGPS.details.retirementGoal,
								style: 'textCell',
							},

						],

						[
							{
								text: (details.financialGPS.details.retired) ? _prints(_translate('pdf.projectWithdrawalIn', details.financialGPS.details.currentYear)) : _translate('financialGps.annualContributions'),
								style: 'labelCell',
							},

							{
								text: (details.financialGPS.details.retired) ? details.financialGPS.details.currentYearWithdrawal : details.financialGPS.details.annualContributions,
								style: 'textCell',
							},

							{
								text: _translate('financialGps.indexation'),
								style: 'labelCell',
							},

							{
								text: details.financialGPS.details.index,
								style: 'textCell',
							},

						],																								

					]

				}

			};

			module[i++] = sectionIntro(_translate('pdf.retirementPortfolioAssumption'));

			module[i++] = {

				margin: [0, -15, 0, 0],
				layout: getTableLayout('profile'),
				table: {

					widths: [130, '*', 130, '*'],
					body: [

						[
							{
								text: _translate('financialGps.rateOfReturnRequired'),
								style: 'labelCell',
							},

							{
								text: details.financialGPS.details.requiredRate,
								style: 'textCell',
							},

							{
								text: _translate('financialGps.rateOfReturnRequiredRetirement'),
								style: 'labelCell',
							},

							{
								text: details.financialGPS.details.retirementRate,
								style: 'textCell',
							},

						],																		

					]

				}

			};

			b = 'before';

		}

		if ( args.useGPSProjections ) {

			module[i++] = {

				text: _translate('financialGps.financialGpsProjections'),
				pageBreak: b,
				style: 'heading2',

			};

			module[i++] = {
				text: _translate('financialGps.financialGpsProjectionsParagraph1'),
				style: 'intro',
				margin: [0, 15, 0, 0],
			};

			module[i++] = {
				text: _translate('financialGps.financialGpsProjectionsParagraph2'),
				style: 'intro',
				margin: [0, 15, 0, 0],
			};

			module[i++] = {

				layout: getTableLayout('noBorder'),
				margin: [0, 15, 0, 0],
				table: {

					widths: [390, '*'],
					body: [

						[ 

							{	

								text: details.financialGPS.charts.accumulationTitle,
								style: 'labelCellLarge',
								colSpan: 2,
								margin: [0, 0, 0, 15],

							}, ''

						],

						[

							sectionGraph(details.financialGPS.charts.accumulation, 380),
							sectionLegend(details.financialGPS.charts.legend),

						],				

					]

				}

			};

			b = 'before';

		}
	

		if ( args.useGPSShock ) {

			module[i++] = {

				text: _translate('financialGps.portfolioResilience'),
				pageBreak: b,
				style: 'heading2',
				
			};

			module[i++] = {

				text: _translate('financialGps.portfolioResilienceParagraph1'),
				style: 'intro',
				margin: [0, 15, 0, 0],

			};

			module[i++] = {

				layout: getTableLayout('noBorder'),
				margin: [0, 15, 0, 0],
				table: {

					widths: [480],
					body: [

						[

							sectionGraph(details.financialGPS.charts.resilience, 420),

						]

					]

				}

			};

			module[i++] = { 

				text: _translate('financialGps.portfolioResilienceParagraph2'),
				style: 'intro',
				margin: [0, 15, 0, 15],

			};

			module[i++] = sectionWealthTable(details.financialGPS.resiliance);	
			
		}


		return module;

	}

	var defaults = {

		// Defines whether or not to include a cover page in the
		// PDF output.
		useCover: true,
		useProfile: true,
		useNetWorth: true,
		useRetirementPlanner: true,
		useFinancialGPS: true,
		useCurrentTool: false,

		useNetworthTotal: true,
    useNetworthComp: true,

    useRetirementOutlook: true,
    useRetirementIncome: true,
    useRetirementBenefits: true,
    useRetirementPension: true,
    useRetirementValues: true,
    useRetirementWealthAccumulation: true,
    useRetirementDeacumulation: true,
    useRetirementCashflows: true,

    useGPSOverview: true,
    useGPSProjections: true,
    useGPSShock: true,		

		firstPage: false,

		details: {},

	}

	for ( var k in defaults ) {

		if ( args[k] === undefined ) {

			args[k] = defaults[k];

		}

	}

	var details = getDetails(),
	    client  = getClientDetails();



	/**
	* ---------------------------------------------------------------------------- /
	* 
	* DEFINE THE ACTUAL MODEL
	*
	* This is where we define the actual model. By defining at as a variable of
	* the enclosing function, we can then return this variable at the end of the
	* function. In this way, we can simply call the enclosing function, use the 
	* parameters that are passed in as part of the object and generate the final 
	* object that will be passed to PDFMake. 
	* 
	* --------------------------------------------------------------------------- */

	var model = {

		// Get /  Define the basic information requirements.
    info: {
      title: details.reportName,
      author: 'Rose & Associates Financial Consultants',
      subject: 'subject of document',
      keywords: 'keywords for document',
    },

    // Set the page size and document boundaries. 
		// We're using a library constant equal to 612 x 792
		pageSize: 'LETTER',
    pageMargins: [60, 60, 60, bottomMargin()],

    // Define the page background.
		background: function(currentPage) {

			if ( currentPage === 1 && args.useCover ) { 

    		return [

					{
						image: 'logo.jpg',
						width: 339,
						height: 120,
						alignment: 'center',
						margin: [0, 240, 0, 20],
					},

		      {

		      	alignment: 'center',
						canvas: [

							{
								type: 'line',
								x1: 286, y1: 0,
								x2: 326, y2: 0,
								lineWidth: 1,
								lineColor: '#f5cc45',
							},

						]		   

					},										

		      {

		        text: details.reportName.toUpperCase(), 
		        margin: [40, 50, 40, detailsMargin()],
		        alignment: 'center',
		        fontSize: 20,
		        bold: false,
		        color: '#103c63',
		        characterSpacing: 1,

		      },

		      {

						layout: {
              hLineWidth: function(i, node) {
                return 0;
              },
              vLineWidth: function(i, node) {
                return 0;
              },
              hLineColor: function(i, node) {
                return 'transparent';
              },
              vLineColor: function(i, node) {
                return 'transparent';
              },
              // paddingLeft: function(i, node) { return 4; },
              // paddingRight: function(i, node) { return 4; },
              // paddingTop: function(i, node) { return 2; },
              // paddingBottom: function(i, node) { return 2; }
            },

		      	table: {

			        // headers are automatically repeated if the table spans over multiple pages
			        // you can declare how many rows should be treated as headers
			        headerRows: 1,
			        widths: [ '*', 'auto' ],
			        margin: [60, 40, 60, 40],

			        body: [
			          [ 

			          	[

							      {

							        text: _translate('pdf.preparedOnBehalf'), 
							        margin: [60, 0, 0, 0],
							        alignment: 'left',
							        fontSize: 8,
							        bold: false,
							        italics: true,
							        color: '#777',
							        characterSpacing: 1,		        

							      },		      

							      {

							        text: details.clientName.toUpperCase(), 
							        margin: [60, 15, 0, 5],
							        alignment: 'left',
							        bold: false,
							        fontSize: 12,
							        color: '#103c63',
							        characterSpacing: 1,

							      },

							      {

							        text: getAddress(details.clientAddress), 
							        margin: [60, 0, 0, 0],
							        alignment: 'left',
							        bold: false,
							        fontSize: 10,
							        lineHeight: 1.4,

							      },

			          	], 

							    {

						        text: details.date.toUpperCase(), 
						        margin: [0, clientAddressMargin(), 60, 0],
						        alignment: 'right',
						        fontSize: 8,
						        bold: false,
						        color: '#333',
						        characterSpacing: 1,	

						      } 

						    ],
		      
			        ]

			      }

		      }
   
	     ]

    	}

    	else {

    		return [

					{

						canvas: [

							{
								type: 'rect',
								x: 563,
								y: 742,
								w: 8,
								h: 8,
								r: 10,
								color: '#f5cc45',
							},

						]		   

					},

					{ 

						text: 'page ' + currentPage,
						fontSize: 6,
						color: '#777',
						alignment: 'right',
						italics: true,
						margin: [40, -8, 55, 0],

					}       		

    		]

    	}

  	},

		footer: function(currentPage, pageCount) { 

			if ( (currentPage > 1 && args.useCover) ||
			     ( ! args.useCover ) ) {

				if ( ! args.useDisclaimer) {

					return false;

				}

	      return {

	        columns: [

						[

				   //    {

				   //    	alignment: 'center',
							// 	canvas: [

							// 		{
							// 			type: 'line',
							// 			x1: 60, y1: 0,
							// 			x2: 100, y2: 0,
							// 			lineWidth: 1,
							// 			lineColor: '#ccc',
							// 		},

							// 	]		   

							// },

		        	{

		        		margin: [60, 10, 120, 0],
		        		text: details.disclaimer,
				        fontSize: 6,
				        color: '#777',
				        italics: true,
				        lineHeight: 1.4,

				        alignment: 'left',	        		
		        	}
	        	]

	        ]

	      };

    	}

    },  	

    content: [

			module_clientProfile(),
			module_netWorth(),
			module_retirementPlan(),
			module_financialGPS(),
			module_tool(),
			module_disclaimers(),

     ],

		styles: pdfMakeStyles()

	};

	return model;

};

window.clientsModel = function (args) {

	console.log(args);
	var clients = args.clients,

	_translate = function (key) {

		var lang = args.printLanguage;

		if (!translations.translations[key]) {
			return '[undefined string]';
		}

		var s = translations.translations[key];
		return (s[lang]) ? s[lang] : s['en'] + ' [' + lang.toUpperCase() + ']';

	},

	bottomMargin = function () {

		var margin = 51,
			  lines = 1;

		margin += 7 + (10 * (lines - 1));

		return margin;

	},

	sectionHeading = function (text) {

		var component = [

			{

				text: text,
				style: 'heading',
				margin: [0, 0, 0, 10],
				pageBreak: false,

			},

			{

				alignment: 'center',
				margin: [0, 0, 40, 0],
				canvas: [

					{
						type: 'line',
						x1: 0, y1: 0,
						x2: 40, y2: 0,
						lineWidth: 1,
						lineColor: '#f5cc45',
					},

				]

			},

		]

		return component;

	},

	module_clientList = function () {
	
		var tableBody = [],
		    tableRow = [],
				tableWidths = [],
		    clientLoop = 0,
				cols = 3,
				width = (100/cols).toFixed(2) + '%';

		for ( var x = 0; x < cols; x++ ) {
			tableWidths.push(width);
		}
				
		for ( var c = 0; c < clients.length; c++ ) {

			if (clientLoop == cols ) {
				clientLoop = 0;
				tableBody.push(tableRow)
				tableRow = []
			}

			tableRow.push({
				text: clients[c].lastName.trim() + ', ' + clients[c].firstName.trim(),
				margin: [0, 0, 10, 10],
				style: 'textCellMedium',
			});

			clientLoop += 1;

		}

		var module = [
			sectionHeading(_translate('pdf.clientListHeading')),
			[

				{

					text: _translate('pdf.clientListIntro'),
					style: 'intro',
					margin: [0, 15, 80, 0],

				}

			],
			{
				layout: {
					hLineWidth: function (i, node) {
						return 0;
					},
					vLineWidth: function (i, node) {
						return 0;
					},
					hLineColor: function (i, node) {
						return 'transparent';
					},
					vLineColor: function (i, node) {
						return 'transparent';
					},
					paddingLeft: function (i, node) { return 0; },
					paddingRight: function (i, node) { return 0; },
					paddingTop: function (i, node) { return 0; },
					paddingBottom: function (i, node) { return 0; }
				},
				margin: [ 0, 20, 0, 0 ],
				table: {
					widths: tableWidths,
					body: tableBody
				}
			}
		];
		return module;

	};

	var model = {
		// Get /  Define the basic information requirements.
		info: {
			title: 'List of Clients',
			author: 'Rose & Associates Financial Consultants',
			subject: 'List of Clients',
			keywords: 'clients, listing',
		},

		// Set the page size and document boundaries. 
		// We're using a library constant equal to 612 x 792
		pageSize: 'LETTER',
		pageMargins: [60, 60, 60, bottomMargin()],

		background: function (currentPage) {
			
			return [

				{

					canvas: [

						{
							type: 'rect',
							x: 563,
							y: 742,
							w: 8,
							h: 8,
							r: 10,
							color: '#f5cc45',
						},

					]

				},

				{

					text: 'page ' + currentPage,
					fontSize: 6,
					color: '#777',
					alignment: 'right',
					italics: true,
					margin: [40, -8, 55, 0],

				}

			]

		},

		content: [

			module_clientList(),

		],

		styles: pdfMakeStyles()

	}

	return model;

}

function pdfMakeStyles() {

	return {

		heading: {
			fontSize: 20,
			bold: false,
			characterSpacing: 1,
			color: '#103c63',
		},

		heading2: {

			fontSize: 14,
			bold: false,
			characterSpacing: 1,
			color: '#103c63',

		},

		intro: {

			fontSize: 10,
			bold: false,
			lineHeight: 1.4,
			characterSpacing: .35,
			color: '#555555',
		},

		tableHeading: {

			fontSize: 12,
			bold: true,
			color: '#103c63',

		},

		tableHeadingVal: {

			fontSize: 12,
			color: '#06a0df',

		},

		textCell: {

			fontSize: 9,

		},

		labelCell: {

			fontSize: 9,
			color: '#103c63',

		},

		labelCellBold: {

			fontSize: 10,
			color: '#103c63',
			bold: true,
			characterSpacing: .75,

		},

		sectionCell: {

			fontSize: 9,
			characterSpacing: .75,
			color: '#103c63'

		},

		textCellSmall: {

			fontSize: 8,

		},

		textCellMedium: {

			fontSize: 10,

		},

		textCellSmallBold: {

			fontSize: 9,
			bold: true,

		},

		labelCellSmall: {

			fontSize: 8,
			color: '#103c63',

		},

		labelCellSmallBold: {

			fontSize: 9,
			color: '#103c63',
			bold: true,

		},

		sectionCellSmall: {

			fontSize: 8,
			characterSpacing: .75,
			color: '#103c63'

		},

		textCellLarge: {

			fontSize: 12,

		},

		labelCellLarge: {

			fontSize: 12,
			color: '#103c63',

		},

		sectionCellLarge: {

			fontSize: 12,
			characterSpacing: .75,
			color: '#103c63'

		}

	}

}

Date.prototype.getMonthName = function(lang) {
    lang = lang && (lang in Date.locale) ? lang : 'en';
    return Date.locale[lang].month_names[this.getMonth()];
};

Date.prototype.getMonthNameShort = function(lang) {
    lang = lang && (lang in Date.locale) ? lang : 'en';
    return Date.locale[lang].month_names_short[this.getMonth()];
};

Date.locale = {
    en: {
       month_names: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
       month_names_short: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    }
};




// WEBPACK FOOTER //
// ./src/pdf/reportModel.js